import { ISite } from '@/types/models';
import utils from '@/utils';
import { AxiosResponse } from 'axios';

const $url = '/api/admin/agent/actions/addSite';

interface IAddSiteRequest {
  securityKey: string;
  siteName: string;
  root: boolean;
  parentId: number;
  siteDir: string;
  themeDownloadUrl: string;
  guid: string;
}

interface IAddSiteResult {
  site: ISite;
}

export default {
  addSite(hostName: string, nodeName: string, isHongKong: boolean, req: IAddSiteRequest, success: (res: IAddSiteResult) => void, failure: (errorMessage: string) => void) {
    utils.loading(true);
    const hostRequest = utils.getHostRequest(hostName, nodeName, isHongKong);
    hostRequest
      .post($url, req)
      .then((response: AxiosResponse<IAddSiteResult>) => {
        success(response.data);
      })
      .catch(error => {
        failure(error.response.data.message);
      })
      .then(() => {
        utils.loading(false);
      });
  },
};
